import { Injectable, Renderer2, RendererFactory2 } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Meta, Title } from "@angular/platform-browser";
import { ContenutoGenerico } from "../model/contenuto-generico";
import { Multilingua } from "../model/multilingua";
import { Blog } from "../model/blog";
import { Careers } from "../model/careers";

@Injectable({
  providedIn: "root",
})
export class SeoService {
  private renderer: Renderer2;

  constructor(
    protected http: HttpClient,
    private title: Title,
    private meta: Meta,
    rendererFactory: RendererFactory2
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  public addSeo(contenutoGenerico: ContenutoGenerico) {
    this.init();
    this.setTitle(contenutoGenerico.titolo);
    this.setLang(contenutoGenerico.lang);
    this.setDescription(contenutoGenerico.sottotitolo);
    this.setKeywords(contenutoGenerico.sottotitolo);
    if (!this.meta.getTag('name = "date"')) {
      this.meta.addTag({
        name: "date",
        content: "2018-10-04",
        scheme: "YYYY-MM-DD",
      });
    }
  }

  public addSeoIt(multilingua: Multilingua) {
    this.init();
    this.setTitle(multilingua.it_title);
    this.setLang("IT");
    this.setDescription(multilingua.it_description);
    this.setKeywords(multilingua.it_keywords);
  }

  public addSeoEn(multilingua: Multilingua) {
    this.init();
    this.setTitle(multilingua.eng_title);
    this.setLang("EN");
    this.setDescription(multilingua.eng_description);
    this.setKeywords(multilingua.eng_keywords);
  }

  public addSeoBlog(blog: Blog) {
    this.init();
    this.setTitle(blog.seo_titolo);
    if (blog.lang) {
      this.setLang(blog.lang);
    } else {
      this.setLang("IT");
    }
    this.setDescription(blog.seo_description);
    this.setKeywords(blog.seo_keywords);
  }

  public addSeoCareer(careers: Careers) {
    this.init();
    this.setTitle(careers.titolo);
    if (careers.lang) {
      this.setLang(careers.lang);
    } else {
      this.setLang("IT");
    }
    this.setDescription(careers.titolo);
    this.setKeywords(careers.titolo);
  }

  public setAll(
    keywords: string,
    title: string,
    description: string,
    lang: string
  ) {
    this.init();
    this.renderer.setAttribute(
      document.querySelector("html"),
      "lang",
      lang.toLocaleLowerCase()
    );
    this.setDescription(description);
    this.setKeywords(keywords);
    this.setTitle(title);
    this.setDate(new Date());
  }

  public init() {
    if (!this.meta.getTag('name = "viewport"')) {
      this.meta.addTag({
        name: "viewport",
        content: "width=device-width, initial-scale=1",
      });
      this.meta.addTag({ name: "robots", content: "INDEX, FOLLOW" });
      this.meta.addTag({ httpEquiv: "Content-Type", content: "text/html" });
      this.meta.addTag({ property: "og:type", content: "website" });
      this.meta.addTag({
        property: "og:site_name",
        content: "servizitalia.it",
      });
      this.meta.addTag({ charset: "UTF-8" });
      this.meta.addTag({ name: "author", content: "Servizi Italia Spa" });
    }
  }

  public setLang(lang: string) {
    if (lang) {
      this.renderer.setAttribute(
        document.querySelector("html"),
        "lang",
        lang.toLocaleLowerCase()
      );
    }
  }

  public setImage(image: string) {
    if (image) {
      if (!this.meta.getTag('name = "og:image"')) {
        this.meta.addTag({ name: "og:image", content: image });
      } else {
        this.meta.updateTag({ name: "og:image", content: image });
      }
    }
  }

  public setDate(dateReal: Date) {
    const data = dateReal.toISOString().slice(0, 10);
    if (!this.meta.getTag('name = "date"')) {
      this.meta.addTag({ name: "date", content: data, scheme: "YYYY-MM-DD" });
    }
  }

  public setTitle(title: string) {
    if (title) {
      this.title.setTitle(title);
      if (!this.meta.getTag('name = "og:title"')) {
        this.meta.addTag({ name: "og:title", content: title });
      } else {
        this.meta.updateTag({ name: "og:title", content: title });
      }
    }
  }

  public setDescription(description: string) {
    if (description) {
      if (!this.meta.getTag('name = "description"')) {
        this.meta.addTag({ name: "description", content: description });
      } else {
        this.meta.updateTag({ name: "description", content: description });
      }
      if (!this.meta.getTag('name = "og:description"')) {
        this.meta.addTag({ name: "og:description", content: description });
      } else {
        this.meta.updateTag({ name: "og:description", content: description });
      }
    }
  }

  public setKeywords(keywords: string) {
    if (keywords) {
      if (!this.meta.getTag('name = "keywords"')) {
        this.meta.addTag({ name: "keywords", content: keywords });
      } else {
        this.meta.updateTag({ name: "keywords", content: keywords });
      }
    }
  }
}
